/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type TeamDropdown_teams$ref: FragmentReference;
declare export opaque type TeamDropdown_teams$fragmentType: TeamDropdown_teams$ref;
export type TeamDropdown_teams = $ReadOnlyArray<{|
  +node: ?{|
    +name: ?string,
    +id: string,
  |},
  +$refType: TeamDropdown_teams$ref,
|}>;
export type TeamDropdown_teams$data = TeamDropdown_teams;
export type TeamDropdown_teams$key = $ReadOnlyArray<{
  +$data?: TeamDropdown_teams$data,
  +$fragmentRefs: TeamDropdown_teams$ref,
  ...
}>;
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "TeamDropdown_teams",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TeamTypeEdge"
};
// prettier-ignore
(node/*: any*/).hash = 'dcc9577bdda4ff58599704d28a66776f';

module.exports = node;
